<template>
  <div class="feedback-container">
    <el-form :rules="rules" @submit.native.prevent :model="feedbackForm" ref="ruleForm" class="feedback-from" label-width="100px"  label-position="right">
      <el-form-item label="问题类型：" prop="type">
        <el-radio-group v-model="feedbackForm.type">
          <el-radio label="0">功能异常</el-radio>
          <el-radio label="1">产品建议</el-radio>
          <el-radio label="2">其他</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="详情描述：" class="desc-form" prop="description">
        <div class="textare-desc">
          <el-input type="textarea" placeholder="请输入内容" :autosize="{ minRows: 4, maxRows: 4}" maxlength="1000" v-model="feedbackForm.description">
          </el-input>
          <i v-show="feedbackForm.description.length>0" class="iconfont icon-close-solid mini close-position" @click.stop="clearTextarea"></i>
          <span class="limit-text">剩余可书写<span class="limit-text-count">{{textCount}}</span>字符</span>
        </div>

      </el-form-item>

      <el-form-item label="上传图片：">
        <span class="img-upload-tip"> （建议图片格式为：JPEG/BMP/PNG/GIF,大小不超过5M，最多可上传4张）</span>
        <el-upload ref="upload-img" action="/resapi/tw/user-feedback-file/imgUpload" list-type="picture-card" multiple :headers="headers" :limit="4" :on-exceed="handlerLimit" :file-list="fileList" :on-success="handleFileSuccess" :before-upload="beforeUpload" :on-preview="handlePictureCardPreview" :before-remove="handleRemove" accept="image/*">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="联系邮箱：" prop="email">
        <el-input type="text" placeholder="请输入内容" v-model="feedbackForm.email" autocomplete="off"></el-input>
      </el-form-item>
      <div class="footer-button">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="submitfeedbackForm">确认提交</el-button>
      </div>
    </el-form>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "feedback",
  components: {
  },
  data() {
    var checkEmail = (rule, value, callback) => {
    const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
     if(value!=''){
      if (mailReg.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的邮箱格式'))
      }
      }else{
         callback();
      }
  }

    return {
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      headers: { authorization: localStorage.getItem('rs_t') },
      fileIdList: [],
      //textCount:1000,//字数限制
      feedbackForm: {
        type: "1",
        description: '',
        email: '',

      },
      rules: {
        type: [
          { required: true, message: '请选择问题类型', trigger: 'change' }
        ],
        description: [
          { required: true, message: '请填写描述信息', trigger: 'blur' }
        ],
        email: [
         { validator: checkEmail, trigger: ['blur', 'change'] }
        ]
      }
    };
  },
  computed: {
    textCount() {
      return (1000 - this.feedbackForm.description.length)
    }
  },
  methods: {
    handleRemove(file) {
    return new Promise((resolve, reject) => { this.$api.post("/resapi/tw/user-feedback-file/deleteImg", {"fileId":file.id}).then(res => {
        if (!res.success) {
          this.$message.error(res.info);
           reject(new Error(res.info));
        }else{
           resolve(true);
        }
      }).catch(error => {
        console.error(error);
          reject(error);
      })

    })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //提交
    submitfeedbackForm() {

       this.$refs.ruleForm.validate((valid) => {
        if (valid) {

      if (this.fileIdList.length > 0) {
          this.feedbackForm.fileIds = this.fileIdList.toString();
      }
      this.$api.post("/resapi/tw/user-feedback/add", this.feedbackForm).then(res => {
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        this.$message.success("提交成功");
        this.resetForm()
      }).catch(error => {
        console.error(error);
      })
       }});
    },
    handleFileSuccess(res, file, fileList) {
      if (!res.success) {
        this.$message.error(res.info);
        for (var i = 0; i < fileList.length; i++) {
          if (file.uid == fileList[i].uid) {
            fileList.splice(i, 1);
          }
        }
      } else {
        file.id = res.data.id
        this.fileIdList.push( res.data.id)
      }
    },
    cancel(){
       this.resetForm();
    },
    resetForm(){
         this.feedbackForm={
           type:'0',
           description: '',
           email: '',
         }
           this.fileIdList=[]
           this.$refs["upload-img"].clearFiles();
    },
    handlerLimit() {
      this.$message.error("最多上传四张图片");
    },
    clearTextarea() {
      this.feedbackForm.description = ""
    },
    beforeUpload(file) {
      let limitSize = 1024 * 1024 * 5;
      if (file.size > limitSize) {
        this.$message.error("图片大小不允许超过5M");
        return false;
      } return true;
    }
  }
}
</script>

<style lang="scss" scoped>
.feedback-container {
  width: 900px;
  margin: 0 auto;
  .feedback-from {
    margin-top: 20px;
    .textare-desc {
      width: calc(100% - 100px);
      position: relative;
      height: 100%;
      display: inline-block;
      min-width: 300px;   
    }
    .img-upload-tip {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      color: #909599;
    }
    .close-position {
      position: absolute;
      right: 8px;
      top: -5px;
    }
    .limit-text {
      position: absolute;
      right: 10px;
      top: 70px;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 17px;
      color: #909599;
      .limit-text-count {
        color: #20ccc6;
      }
    }
  }
  .footer-button{
    margin-top: 15px;
     .el-button{
       margin-left: 20px;
        margin-right: 20px;
     }
  }
}
</style>